import React, { useEffect, useRef } from "react";
/**
 * ```tsx
 * import React from "react"
 *
 * import { Iframe } from "@bounce/iframe"
 *
 * const App = () => (
 *   <Iframe uri="https://usebounce.com/careers" style={{ flex: 1 }} />
 * )
 *
 * export default App
 * ```
 *
 * @category Component
 */
const Iframe = _ref => {
  let {
    uri,
    style,
    onLoadEnd
  } = _ref;
  const ref = useRef(null);
  useEffect(() => {
    const iframe = ref.current;
    if (!onLoadEnd || !iframe) return;
    iframe.addEventListener("load", onLoadEnd);
    return () => {
      iframe.removeEventListener("load", onLoadEnd);
    };
  }, [ref, onLoadEnd]);
  return /*#__PURE__*/React.createElement("iframe", {
    ref: ref,
    src: uri,
    style: style,
    sandbox: "allow-same-origin allow-scripts",
    frameBorder: "0"
  });
};
export { Iframe };
//# sourceMappingURL=Iframe.js.map